import { Component } from '@angular/core';
import { environment } from '../../../Environment/environment';

@Component({
    selector: 'app-header-spinea',
  templateUrl: './header-spinea.component.html',
  styleUrls: ['./header-spinea.component.css']
})
export class HeaderspineaComponent {
   AssetbasePath = environment.assetsPath;
}
